module.exports = __webpack_public_path__ + "img/close_icon.e910b15b.svg";